import React, { useEffect, useState, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import api from "../services/api";

const QZ_CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIECzCCAvOgAwIBAgIGAZy70fWdMA0GCSqGSIb3DQEBCwUAMIGiMQswCQYDVQQG
EwJVUzELMAkGA1UECAwCTlkxEjAQBgNVBAcMCUNhbmFzdG90YTEbMBkGA1UECgwS
UVogSW5kdXN0cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMx
HDAaBgkqhkiG9w0BCQEWDXN1cHBvcnRAcXouaW8xGjAYBgNVBAMMEVFaIFRyYXkg
RGVtbyBDZXJ0MB4XDTI2MDMwNDAyMjcwNVoXDTQ2MDMwNDAyMjcwNVowgaIxCzAJ
BgNVBAYTAlVTMQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYD
VQQKDBJRWiBJbmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMs
IExMQzEcMBoGCSqGSIb3DQEJARYNc3VwcG9ydEBxei5pbzEaMBgGA1UEAwwRUVog
VHJheSBEZW1vIENlcnQwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDy
BEjLPM5nHTgzlzaPyk0ABxRztPyF1p/4p4e2JHNAWIt2yXS0L4Zdi6d0eofioGSc
8I+KuhP+c7nm1NWV3Xext4Vse1dQQqXLZzxlpEfSqzu6CRBAVq6bl8hhcRBHklQ8
wJF4Mh9LcDv7DQNSXK49JuLYOFM6hFX/h72/ZU/DilOlLCEJw7/ks8u48aLtzkRr
rT2ngVWgNdHxzX5pxhdb+Ckay1w4aMcktRcWvyJM+iYWt2eBYOZTaeJQB7THiL/N
hQwBQ+Y1ICn/3InZPeOm1dcwwoMCjsBtrAbsulhkd0PbNYZYUCU1tZx6M+WYOLGH
uxPPeM9AaI24xaiJEMslAgMBAAGjRTBDMBIGA1UdEwEB/wQIMAYBAf8CAQEwDgYD
VR0PAQH/BAQDAgEGMB0GA1UdDgQWBBQpIWj5KJSZl7tJTArHXlrHW4v9jTANBgkq
hkiG9w0BAQsFAAOCAQEAl7NpeyAlVvM6SkbCmkhFKZKTyOysA3smLz1E7eV5ZqQv
7mqZyIdWO6XJc9RWCOu21kZ765ADXnM/PvMHjHzKk1DeODwASFrlMaXPDskSad5g
ga/0k5r5NJse0Z+eUQZ4Ng1ZKRwLiblUuBxw87wxMQGp2jiOi/EQ0ZAoTW91F9bX
/6y2TA309JWAH5cFtZLs0HPtertJjoU2bDzk9Iz8exyJFS0WQsQzxU8Js0zr6d4N
loYITv0ymJ3TdOMomPYs7zVxAphUevg0ebCgC8+VI95kMDt5TadFsXHLJbl8rCD0
6wRUuC42VRXsVXuOUu8GXGchNgOcvqHW1YmtND+qMA==
-----END CERTIFICATE-----`;

const QZ_PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDyBEjLPM5nHTgz
lzaPyk0ABxRztPyF1p/4p4e2JHNAWIt2yXS0L4Zdi6d0eofioGSc8I+KuhP+c7nm
1NWV3Xext4Vse1dQQqXLZzxlpEfSqzu6CRBAVq6bl8hhcRBHklQ8wJF4Mh9LcDv7
DQNSXK49JuLYOFM6hFX/h72/ZU/DilOlLCEJw7/ks8u48aLtzkRrrT2ngVWgNdHx
zX5pxhdb+Ckay1w4aMcktRcWvyJM+iYWt2eBYOZTaeJQB7THiL/NhQwBQ+Y1ICn/
3InZPeOm1dcwwoMCjsBtrAbsulhkd0PbNYZYUCU1tZx6M+WYOLGHuxPPeM9AaI24
xaiJEMslAgMBAAECggEASSLsUKbOhTC6VDTlIyzyegipsJHIIjYK39zY0T1QquhX
NQ2KPA2EoG5cq4F/4QexgA/egQDcm++jBVPaO9DSpB0er/rSFwodCkvnX5v2rH5c
rUqh45+OYqzKvE+rqMVauYVEMLuM44JGTgbPsysY6JgAw3C6DhwB1RfTSqy2HxPu
4CdSlaAqigE7ksPrBu04/av4OdtNQxElnojvEEqX6Qnimhj2kgd4GtROGlPYlBgc
vp9AQlAzStmLgJMp4zmObAq82/WVA4nFUlrdZT2zuKkxBGzPYdaChWhIW4NFpPUT
nWbWll1N0dk8ZMqiuzRBDyZjgiAYN/13W8qSPFIi/QKBgQD8gZ7tDXVQn4ds5Vhd
bmtnOk7fiFXTZLpKICDHW/pp8ou+eDdxALloAgdS1Ecp/f0hkjgAeuddcEki0qLP
TTRrD0ssq6NmoMtQHioIqqsRS5E7brPBqPAqHmTMOCXLI/UgfxOqghY2Zgg3RT0P
bD1ds8fx3oubO2Ha0Im21PJEUwKBgQD1XYJjKo8WqPpnYjSKp2OWxfDfYmDkRYIC
sq8PUqTiPsh+SGlU89lGrPF2DIq6EgvOnpUbVgqbz25GFkZLZQI3bpmDa+E+xEow
XjlnZKRPpNF3r7sTHJwqU6MIc55s2zyMx0UviwzHpLXidbKHWdfuvbyt/O1T+MAh
k5Ue17nDpwKBgG4H1ccajDp7qbmsHttn2Gl9IQ2LDUs2o27VnTMCQ5aTWI3BOPeH
B0PpTmOrmO8VfI56dujOpa8z1MrV2phW3jagzXNDv8pi2vWoj0yDglPhCAJL9Qy4
nx7ba7UJ6n4gxxpIBbvRP/iocYAULc1gr0T7qG8fONqF/9gn8zq2hHN9AoGBAL27
ChkOjsjR75dD7CcPWsX619CUrSG20dquOwoZOOCt9bEY40JKsUeicbB78EYDsFec
buZNeTSUiMvva3nfaIBeqJxkLi+v70JJig/2Vcw0QblQDNOxetyMAfSGGwpH2SFu
8YPa/Q3fwrmTk3JwObYlx6GuhAI7xq3wBg5sd/vfAoGBAMtMIh0VnTnFXBbLQ0bz
BAM4fY5xjbwCUDm2HJzsuZ8w5b9H69Ogh7hG9gk/XaBP7jbk+3icbmo03cowwXyF
FfoAOlcPBgHqvut1n9UH37WRF/vcsup81rQjqgS/s8TPKG9fmbuRgPJ2ALjStTB4
9qLkf2Fe9mvvdHK4m+TgsBjO
-----END PRIVATE KEY-----`;

const ESC = '\x1B';
const GS  = '\x1D';
const CMD = {
  INIT:         ESC + '@',
  ALIGN_LEFT:   ESC + 'a\x00',
  ALIGN_CENTER: ESC + 'a\x01',
  ALIGN_RIGHT:  ESC + 'a\x02',
  BOLD_ON:      ESC + 'E\x01',
  BOLD_OFF:     ESC + 'E\x00',
  SIZE_NORMAL:  GS  + '!\x00',
  SIZE_WIDE:    GS  + '!\x10',
  CUT:          GS  + 'V\x41\x03',
  FEED:         ESC + 'd\x04',
  LF:           '\n',
};

const trunc = (text, max) => { const s = String(text ?? ''); return s.length > max ? s.substring(0, max-1) + '.' : s; };
const rowLR = (left, right, width = 48) => { const l = String(left); const r = String(right); const sp = width - l.length - r.length; return l + (sp > 0 ? ' '.repeat(sp) : ' ') + r; };
const separator = (char = '-', width = 48) => char.repeat(width);

const generarESCPOS = (invoice, company) => {
  const sale    = invoice;
  const fel     = invoice.invoice;
  const client  = invoice.client ?? {};
  const details = invoice.sale_details ?? invoice.saleDetails ?? [];
  const efectivo = Number(invoice.cash ?? sale.cash ?? 0);
  const cambio   = Number(invoice.change ?? sale.change ?? 0);
  const numeroControl = fel?.numero_control ?? 'N/A';
  const codigoGen     = fel?.codigo_generacion ?? '';
  const sello         = fel?.sello_recepcion ?? '';
  const fecha         = fel?.fecha_emision ?? new Date().toLocaleDateString();
  const tipoDoc       = fel?.tipo_documento || sale?.tipo_documento || '01';
  const esCF          = tipoDoc === '03';
  const tituloDoc     = esCF ? 'CREDITO FISCAL' : 'CONSUMIDOR FINAL';

  let c = '';
  c += CMD.INIT;
  c += CMD.ALIGN_CENTER + CMD.BOLD_ON + 'EMISOR' + CMD.LF;
  c += CMD.SIZE_WIDE + (company?.nombre_comercial || company?.nombre || 'RESTAURANTE') + CMD.LF;
  c += CMD.SIZE_NORMAL + CMD.BOLD_OFF;
  if (company?.nombre) c += CMD.ALIGN_CENTER + company.nombre + CMD.LF;
  c += CMD.ALIGN_LEFT;
  if (company?.nit)            c += 'NIT: ' + company.nit + CMD.LF;
  if (company?.nrc)            c += 'NRC: ' + company.nrc + CMD.LF;
  if (company?.desc_actividad) c += 'Act: ' + trunc(company.desc_actividad, 42) + CMD.LF;
  if (company?.direccion)      c += 'Dir: ' + trunc(company.direccion, 42) + CMD.LF;
  if (company?.telefono)       c += 'Tel: ' + company.telefono + CMD.LF;
  if (company?.email)          c += 'Email: ' + trunc(company.email, 38) + CMD.LF;
  c += separator() + CMD.LF;
  c += CMD.ALIGN_CENTER + CMD.BOLD_ON + 'DOCUMENTO TRIBUTARIO ELECTRONICO' + CMD.LF + tituloDoc + CMD.LF + CMD.BOLD_OFF;
  c += CMD.ALIGN_LEFT + separator() + CMD.LF;
  c += 'Num. Control:' + CMD.LF + trunc(numeroControl, 48) + CMD.LF;
  c += 'Cod. Generacion:' + CMD.LF + trunc(codigoGen, 48) + CMD.LF;
  if (sello) c += 'Sello:' + CMD.LF + trunc(sello, 48) + CMD.LF;
  c += 'Fecha: ' + fecha + CMD.LF;
  c += separator() + CMD.LF;
  c += rowLR('Cajero:', sale?.cajero ?? 'Sistema') + CMD.LF;
  c += rowLR('Caja:', sale?.caja ?? 'Caja 1') + CMD.LF;
  c += separator() + CMD.LF;
  c += CMD.BOLD_ON + 'CLIENTE' + CMD.BOLD_OFF + CMD.LF;
  c += (client?.nombre || 'clientes varios') + CMD.LF;
  if (esCF) {
    if (client?.nit || client?.numero_documento) c += 'NIT: ' + (client.nit || client.numero_documento) + CMD.LF;
    if (client?.nrc) c += 'NRC: ' + client.nrc + CMD.LF;
  }
  c += separator() + CMD.LF;
  c += CMD.BOLD_ON + 'Descripcion              Cant  P.U.    Total' + CMD.LF + CMD.BOLD_OFF;
  c += separator('-') + CMD.LF;
  details.forEach(item => {
    const nombre = trunc(item.nombre_producto_snapshot ?? item.product?.nombre ?? 'Producto', 24);
    const cant   = Number(item.cantidad);
    const precio = Number(item.precio_unitario_snapshot ?? 0);
    const total  = cant * precio;
    c += nombre + CMD.LF;
    c += CMD.ALIGN_RIGHT + cant + '  $' + precio.toFixed(2) + '  $' + total.toFixed(2) + CMD.LF;
    c += CMD.ALIGN_LEFT;
  });
  c += separator() + CMD.LF;
  c += CMD.BOLD_ON + CMD.SIZE_WIDE + rowLR('TOTAL:', '$' + Number(sale?.monto_final ?? 0).toFixed(2), 24) + CMD.LF;
  c += CMD.SIZE_NORMAL + CMD.BOLD_OFF;
  if (sale?.monto_letras) c += trunc(sale.monto_letras, 48) + CMD.LF;
  c += separator() + CMD.LF;
  c += rowLR('Efectivo:', '$' + efectivo.toFixed(2)) + CMD.LF;
  c += CMD.BOLD_ON + rowLR('Cambio:', '$' + cambio.toFixed(2)) + CMD.BOLD_OFF + CMD.LF;
  c += separator() + CMD.LF;
  c += CMD.ALIGN_CENTER + CMD.BOLD_ON + '*** GRACIAS POR SU COMPRA ***' + CMD.LF + CMD.BOLD_OFF;
  c += 'Conserve este documento para reclamos' + CMD.LF;
  if (codigoGen) {
    c += separator() + CMD.LF;
    c += CMD.ALIGN_CENTER + 'Escanee para descargar PDF y JSON' + CMD.LF;
  }
  c += CMD.FEED;
  // SIN CUT aqui - el corte va despues de la imagen QR
  return c;
};

export default function Ticket({ invoice, onAfterPrint }) {
  const [company, setCompany] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);
  const ticketRef = useRef(null);

  // ── useEffect 1: cargar datos de empresa ──
  useEffect(() => {
    api.get('/company/info')
      .then(r => { setCompany(r.data); setIsReady(true); })
      .catch(err => {
        setError(err.message);
        setCompany({ nombre: "EMPRESA DEMO", direccion: "N/A", telefono: "0000-0000", email: "info@empresa.com", nit: "0000-000000-000-0", nrc: "000000-0" });
        setIsReady(true);
      });
  }, []);

  // ── useEffect 2: conectar QZ Tray al cargar la pagina ──
  useEffect(() => {
    const qz = window.qz;
    if (!qz) { console.warn('QZ Tray no disponible'); return; }

    qz.security.setCertificatePromise(function(resolve, reject) {
      resolve(QZ_CERTIFICATE);
    });
    qz.security.setSignatureAlgorithm('SHA512');
    qz.security.setSignaturePromise(function(toSign) {
      return function(resolve, reject) {
        const pemBody = QZ_PRIVATE_KEY
          .replace(/-----BEGIN PRIVATE KEY-----/, '')
          .replace(/-----END PRIVATE KEY-----/, '')
          .replace(/\s+/g, '');
        const binaryStr = atob(pemBody);
        const keyBuffer = new Uint8Array(binaryStr.length);
        for (let i = 0; i < binaryStr.length; i++) keyBuffer[i] = binaryStr.charCodeAt(i);
        window.crypto.subtle.importKey('pkcs8', keyBuffer.buffer, { name: 'RSASSA-PKCS1-v1_5', hash: { name: 'SHA-512' } }, false, ['sign'])
          .then(function(cryptoKey) {
            return window.crypto.subtle.sign({ name: 'RSASSA-PKCS1-v1_5' }, cryptoKey, new TextEncoder().encode(toSign));
          })
          .then(function(signature) {
            resolve(btoa(String.fromCharCode(...new Uint8Array(signature))));
          })
          .catch(reject);
      };
    });

    qz.websocket.connect()
      .then(function() { console.log('QZ listo!'); })
      .catch(function(e) { console.error('QZ error:', e); });
  }, []);

  // ── useEffect 3: imprimir cuando llega la factura ──
  useEffect(() => {
    if (!invoice || !isReady) return;

    console.log('EJECUTANDO IMPRESION', invoice, isReady);
    const timer = setTimeout(async () => {
      try {
        const qz = window.qz;

        if (!qz || !qz.websocket.isActive()) {
          throw new Error('QZ Tray no conectado');
        }

        const impresora = await qz.printers.getDefault();
        console.log('Imprimiendo en:', impresora);

        const datos = [{ type: 'raw', format: 'command', data: generarESCPOS(invoice, company) }];

if (invoice?.invoice?.codigo_generacion) {
const originalCanvas = document.querySelector('.tqr canvas');
const canvas = document.createElement('canvas');
const scale = 1.9; // aumentar a 3 si sigue sin poder escanearse
canvas.width = originalCanvas.width * scale;
canvas.height = originalCanvas.height * scale;
const ctx2 = canvas.getContext('2d');
ctx2.drawImage(originalCanvas, 0, 0, canvas.width, canvas.height);
const ctx = ctx2;
  if (canvas) {
    // Convertir canvas a bitmap monocromatico ESC/POS (GS v 0)
    const w = canvas.width;
    const h = canvas.height;
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, w, h);
    const bytesPerRow = Math.ceil(w / 8);
    let bmp = '';
    // Comando GS v 0: ESC/POS raster bitmap
    bmp += GS + 'v0' + '\x00'; // normal density
    bmp += String.fromCharCode(bytesPerRow & 0xff, (bytesPerRow >> 8) & 0xff); // width in bytes
    bmp += String.fromCharCode(h & 0xff, (h >> 8) & 0xff); // height in lines
    for (let y = 0; y < h; y++) {
      for (let bx = 0; bx < bytesPerRow; bx++) {
        let byte = 0;
        for (let bit = 0; bit < 8; bit++) {
          const x = bx * 8 + bit;
          if (x < w) {
            const idx = (y * w + x) * 4;
            const brightness = imageData.data[idx] * 0.299 + imageData.data[idx+1] * 0.587 + imageData.data[idx+2] * 0.114;
            if (brightness < 128) byte |= (0x80 >> bit); // pixel negro
          }
        }
        bmp += String.fromCharCode(byte);
      }
    }
    datos.push({ type: 'raw', format: 'command', data: CMD.ALIGN_CENTER + bmp });
  }
}

        // Corte al final
        datos.push({ type: 'raw', format: 'command', data: CMD.FEED + CMD.CUT });

        await qz.print(qz.configs.create(impresora), datos);
        console.log('Impresion enviada correctamente');

      } catch (err) {
        console.error('Error QZ:', err);
        const styleId = 'dynamic-page-size';
        let style = document.getElementById(styleId);
        if (!style) { style = document.createElement('style'); style.id = styleId; document.head.appendChild(style); }
        const altoMm = Math.ceil((ticketRef.current?.offsetHeight || 500) * 0.264583 * 1.2) + 15;
        style.innerHTML = `@page { size: 80mm ${altoMm}mm; margin: 0; }`;
        window.print();
      }

      if (onAfterPrint) onAfterPrint();
    }, 1500);

    return () => clearTimeout(timer);
  }, [invoice, isReady, company, onAfterPrint]);

  if (!invoice || !isReady) return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', fontSize:'18px' }}>Cargando...</div>
  );

  const sale = invoice, fel = invoice.invoice, client = invoice.client ?? {};
  const details = invoice.sale_details ?? invoice.saleDetails ?? [];
  const efectivo = invoice.cash ?? sale.cash ?? 0;
  const cambio   = invoice.change ?? sale.change ?? 0;
  const numeroControl = fel?.numero_control;
  const tipoDocumento = fel?.tipo_documento || sale?.tipo_documento || "01";
  const esCreditoFiscal = tipoDocumento === "03";
  const esConsumidorFinal = tipoDocumento === "01";
  const obtenerTituloDocumento = () => esCreditoFiscal ? "CRÉDITO FISCAL" : esConsumidorFinal ? "CONSUMIDOR FINAL" : "FACTURA";
  const obtenerNombreTipoDocumento = (c) => ({ '36':'NIT','13':'DUI','37':'Otro','03':'Pasaporte','02':'Carnet de Residente' }[c] || 'Documento');

  return (
    <>
      <style>{`
        *{margin:0;padding:0;box-sizing:border-box}body{background:#f7fafc}
        .tw{display:flex;justify-content:center;align-items:center;min-height:100vh;padding:20px}
        .t{width:80mm;font-family:Arial,sans-serif;font-size:12px;color:#000;background:white;padding:8mm;box-shadow:0 4px 12px rgba(0,0,0,.15);margin:0 auto}
        .tc{text-align:center}.tco{font-weight:bold;font-size:14px;margin-bottom:6px}
        .ti{font-size:10px;line-height:1.4}.til{margin:2px 0}
        .td{border:none;border-top:1px dashed #000;margin:10px 0}
        .tst{font-weight:bold;font-size:13px;text-align:center;margin:10px 0 6px 0}
        .tr{display:flex;justify-content:space-between;margin:4px 0;font-size:11px}.trb{font-weight:bold}
        .tth{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;font-weight:bold;border-bottom:1px solid #000;padding-bottom:4px;margin-bottom:6px;font-size:10px}
        .ttr{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;margin:4px 0;font-size:10px}
        .ttc{text-align:right}.ttc:first-child{text-align:left}
        .ttot{font-size:15px;font-weight:bold;margin:10px 0}.tqr{text-align:center;margin:12px 0}
        .tf{text-align:center;margin-top:12px}.ts{font-size:10px}.tb{font-weight:bold}
        .eb{background:#fee;border:1px solid #fcc;padding:8px;margin-bottom:10px;border-radius:4px;font-size:10px;color:#c00}
        .qb{background:#d1fae5;border:1px solid #6ee7b7;padding:4px 8px;border-radius:4px;font-size:10px;color:#065f46;text-align:center;margin-bottom:8px}
        @media print{*{visibility:hidden}.tw,.tw *{visibility:visible}html,body{margin:0!important;padding:0!important;background:white!important}
        .tw{position:absolute;left:0;top:0;width:80mm;padding:0;margin:0}.t{box-shadow:none;margin:0;padding:5mm;width:80mm}.eb,.qb{display:none}}
      `}</style>
      <div className="tw">
        <div className="t" ref={ticketRef}>
          <div className="qb">✅ Impresión directa activa (ESC/POS)</div>
          {error && <div className="eb">⚠️ No se pudieron cargar datos de empresa.</div>}
          <div className="tc">
            <div className="tst" style={{marginTop:0}}>EMISOR</div>
            <div className="tco">{company?.nombre_comercial || company?.nombre || 'RESTAURANTE'}</div>
            <div className="ti"><div className="til">{company?.nombre || ''}</div></div>
            <div className="ti">
              <div className="til"><strong>NIT:</strong> {company?.nit || 'N/A'}</div>
              <div className="til"><strong>NRC:</strong> {company?.nrc || 'N/A'}</div>
              {company?.desc_actividad && <div className="til"><strong>Actividad:</strong> {company.desc_actividad}</div>}
              <div className="til"><strong>Dirección:</strong> {company?.direccion || 'N/A'}</div>
              <div className="til"><strong>Tel:</strong> {company?.telefono || 'N/A'}</div>
              <div className="til"><strong>Email:</strong> {company?.email || 'N/A'}</div>
            </div>
          </div>
          <hr className="td"/>
          <div className="tst">DOCUMENTO TRIBUTARIO ELECTRÓNICO</div>
          <div className="tc"><div className="tb" style={{fontSize:'14px'}}>{obtenerTituloDocumento()}</div></div>
          <hr className="td"/>
          <div className="ts">
            <div><strong>Número Control:</strong></div>
            <div style={{wordBreak:'break-all',marginBottom:'4px'}}>{numeroControl||'N/A'}</div>
            <div><strong>Código Generación:</strong></div>
            <div style={{wordBreak:'break-all',marginBottom:'4px'}}>{fel?.codigo_generacion||'N/A'}</div>
            {fel?.sello_recepcion && <><div><strong>Sello de Recepción:</strong></div><div style={{wordBreak:'break-all',marginBottom:'4px'}}>{fel.sello_recepcion}</div></>}
            <div><strong>Fecha:</strong> {fel?.fecha_emision||new Date().toLocaleDateString()}</div>
          </div>
          <hr className="td"/>
          <div className="tr"><span><strong>Cajero:</strong></span><span>{sale?.cajero??"Sistema"}</span></div>
          <div className="tr"><span><strong>Caja:</strong></span><span>{sale?.caja??"Caja 1"}</span></div>
          <hr className="td"/>
          <div className="tb" style={{marginBottom:'4px'}}>CLIENTE</div>
          {esConsumidorFinal ? <div>{client?.nombre||'clientes varios'}</div> : (
            <div>
              <div><strong>Nombre:</strong> {client?.nombre||'Cliente General'}</div>
              {(client?.numero_documento||client?.nit) && <div><strong>{obtenerNombreTipoDocumento(client.tipo_documento)}:</strong> {client.numero_documento||client.nit}</div>}
              {client?.nrc && <div><strong>NRC:</strong> {client.nrc}</div>}
              {(client?.desc_actividad||client?.giro) && <div><strong>Giro:</strong> {client.desc_actividad||client.giro}</div>}
            </div>
          )}
          <hr className="td"/>
          <div className="tth"><div>Descripción</div><div className="ttc">Cant.</div><div className="ttc">P.U.</div><div className="ttc">Total</div></div>
          {details.map((item,i) => (
            <div key={i} className="ttr">
              <div>{item.nombre_producto_snapshot??item.product?.nombre??"Producto"}</div>
              <div className="ttc">{item.cantidad}</div>
              <div className="ttc">${Number(item.precio_unitario_snapshot??0).toFixed(2)}</div>
              <div className="ttc">${(Number(item.cantidad)*Number(item.precio_unitario_snapshot??0)).toFixed(2)}</div>
            </div>
          ))}
          <hr className="td"/>
          <div className="tr ttot"><span>TOTAL:</span><span>${Number(sale?.monto_final??0).toFixed(2)}</span></div>
          {sale?.monto_letras && <div className="tc ts" style={{marginTop:'6px'}}>{sale.monto_letras}</div>}
          <hr className="td"/>
          <div className="tr"><span>Efectivo Recibido:</span><span>${Number(efectivo).toFixed(2)}</span></div>
          <div className="tr trb"><span>Cambio:</span><span>${Number(cambio).toFixed(2)}</span></div>
          <hr className="td"/>
          {fel?.codigo_generacion && (
            <div className="tqr">
              <QRCodeCanvas value={`${process.env.REACT_APP_URL||"https://restaurante.altivaweb.com/BACK/public"}/factura/${fel.codigo_generacion}`} size={140} level="M" includeMargin={true}/>
              <div className="ts" style={{marginTop:'8px'}}>Escanee para descargar PDF y JSON</div>
            </div>
          )}
          <hr className="td"/>
          <div className="tf tb" style={{fontSize:'13px'}}>¡GRACIAS POR SU COMPRA!</div>
          <div className="tf ts" style={{marginTop:'6px'}}>Conserve este documento para cualquier reclamo</div>
        </div>
      </div>
    </>
  );
}